
import { Component, Vue } from 'vue-property-decorator';
import { GlobalAlert } from '~/plugins/alerts/types';
import { getGlobalAlerts, removeGlobalAlert } from '~/plugins/alerts/state';
import Alert from './GlobalAlert.vue';

@Component({ components: { Alert } })
export default class GlobalAlerts extends Vue {
  get alerts(): Array<GlobalAlert> {
    return getGlobalAlerts();
  }

  remove(id: number) {
    removeGlobalAlert(id);
  }
}
